import {FC, SVGProps} from 'react';
import {CardIcon} from '@rocket-ui/icons';
import {AccountPaymentIcon, PhonePaymentIcon} from 'shared/assets/icons';
import type {ProfilePaymentMethod} from './paymentMethod';

export const PAYMENT_METHOD_ICONS: Record<ProfilePaymentMethod, FC<SVGProps<SVGSVGElement>>> = {
	sbp_account: PhonePaymentIcon,
	bank_card: CardIcon,
	executor_account: AccountPaymentIcon,
};
